<template>
  <div class="step-content">
    <v-card 
      v-if="!!this.controller.selected||hasSlots"
      flat
      color="transparent"
      class="calendar text-left mx-n4 my-8"
    >
      <calendar-view
        :slots="controller.slots"
        :hive="hive"
        :selected="controller.selected"
        :loading="controller.loading"
        :cancelable="controller.cancelable"
        @select="setSelectedSlot"
        @refresh="getCalendarSlots"
        @cancel="cancelSelectedSlot"
      />
    </v-card>

    <v-card 
      outlined
      color="transparent"
      class="faq text-left mx-n4 my-8 mt-12"
    >
      <v-list 
        flat
        color="transparent"
        class="py-0"
      >
        <v-list-item
          class="faq-item py-2"
        >
          <v-list-item-icon class="mr-4">
            <v-icon color="primary">{{ icons.mdiInformationOutline }}</v-icon>
          </v-list-item-icon>

          <v-list-item-content>
            <v-list-item-title class="text-subtitle-1 font-weight-medium">
              {{ $t('signup.steps.REA.orientations.title') }}
            </v-list-item-title>
            <v-list-item-subtitle class="item-subtitle mt-2">
              {{ $t('signup.steps.REA.orientations.text') }}
            </v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>

        <v-list-item
          v-for="(faq, key) in faqList"
          :key="key"
          class="faq-item py-1 secondary--text"
          @click="toggleHelp(true, 'activation', faq.section, faq.id)"
        >
          <v-list-item-title v-text="!!helpContent ? (!!faq.item ? helpContent[faq.section].items[faq.item] : helpContent[faq.section]).title : null" />
        </v-list-item>
      </v-list>
      <!-- <v-divider class="mt-0" />
      <v-card-actions>
        <v-spacer />
        <v-btn
          color="primary"
          text
          @click="toggleHelp(true, 'activation')"
        >
          Ver mais
        </v-btn>
      </v-card-actions> -->
    </v-card>

    <referral-card 
      v-if="!!helpContent?.referrals"
      :user="user"
      @help="toggleHelp"
    />

    <slot name="quick-access" />

    <v-btn 
      text
      small
      class="help-btn"
      color="grey"
      @click="toggleHelp(true, 'signup')"
    >
      <v-icon
        small
        class="mr-4"
      >
        {{ icons.mdiHelpCircleOutline }}
      </v-icon>
      {{ $t('general.need_help') }}
    </v-btn>
  </div>
</template>

<style>

  .step-content .item-title {
    margin: 6px 0;
  }

  .step-content .item-subtitle {
    line-height: 1.4;
    text-overflow: initial;
    white-space: initial;
  }

  .step-content .calendar {
    max-width: initial;
  }
  .step-content .faq {
    max-width: initial;
    border-color: var(--v-grey-darken3) !important;
  }

  .step-content .faq .faq-item:not(:last-child) {
    border-bottom: 1px solid var(--v-grey-darken3) !important;
  }

</style>

<script>

  // Icons
  import {
    mdiHelpCircleOutline,
    mdiInformationOutline,
    mdiClose,
    mdiCalendarAlert,
    mdiCheck
  } from '@mdi/js'

  // Utilities
  import services from '@/services.js'
  import { sync, get } from 'vuex-pathify'
  import _ from 'lodash';


  export default {
    name: 'Step6',

    props: {
      step: {
        type: Object,
        default: () => {}
      },
      hive: {
        type: Object,
        default: () => null
      },
      appURL: {
        type: String,
        default: ''
      },
      helpContent: {
        type: Object,
        default: () => {}
      },
      refresh: {
        type: Boolean,
        default: false
      }
    },

    components: {
      ReferralCard: () => import('@/components/ReferralCard'),
      CalendarView: () => import('@/components/CalendarView'),
    },

    data: () => ({
      api: process.env.VUE_APP_ROOT_API,
      icons: {
        mdiHelpCircleOutline,
        mdiInformationOutline,
        mdiClose,
        mdiCalendarAlert,
        mdiCheck
      },
      controller: {
        toggle: false,
        slots: {},
        selected: null,
        loading: false,
        cancelable: true,
      },
      faq: [
        {
          section: 'signup',
          item: 3,
        },
        {
          section: 'manual',
          item: null,
        },
      ],
    }),

    computed: {
      user: sync('user'),
      status: sync('user/status'),
      toast: sync('app/toast'),
      help: sync('app/views@help'),
      help_sections: sync('help/sections'),

      stepName () {
        return this.$options.name.toLowerCase();
      },

      hasSlots () {
        return _.size(this.controller.slots)>0;
      },

      faqList () {
        const faq = this.faq;
        const help = this.helpContent;
        const list = _.reduce(faq, (list, item) => {
          if (item.section in help && (item.id==null || item.id in help[item.section].items)) {
            list.push(item);
          }
          return list;
        }, []);
        return list
      },
    },

    watch: {
      refresh (b) {
        if (b) this.getCalendarSlots();
      }
    },

    methods: {
      ...services,
      
      openLocation (uri, target) {
        window.open(uri, target);
      },
      
      actionCalled () {
        if (this.completion==100) {
          this.toggleConfirm(true);
        }
      },


      setSelectedSlot (slot) {
        this.controller.loading = true;

        const id = slot.id;

        this.$api.get('/driver/schedule/select/'+id+'/', { params: { issue: 1 } })
          .then(response => {
            console.log('setSelectedSlot => ',response);
            if(response.status==200){
              this.controller.selected = slot;

              const step = this.setStepText();
              // propagate updated step to parent
              this.$nextTick(() => {
                this.$emit('update', step);
              });

              this.toggleToast(
                true,
                this.$t('signup.steps.SCH.scheduled'),
                5000,
                false,
              );

              this.trackEvent('signup/'+this.stepName, 'confirm installation ok');
            }else{
              this.toggleToast(
                true,
                this.$t('signup.steps.SCH.errors.select'),
                5000,
                false,
              );
              this.trackEvent('signup/'+this.stepName, 'confirm installation failed');
            }
          })
          .catch(error => {
            if (error.response?.status==404) {
              this.toggleToast(
                true,
                this.$t('signup.steps.SCH.errors.unavailable'),
                5000,
                false,
              );
              this.trackEvent('signup/'+this.stepName, 'installation slot taken');
            } else {
              this.handleError(error, this.$t('calendar.schedule_problem'), true);
            }
          })
          .finally(() => {
            this.getCalendarSlots();
            this.controller.loading = false;
          });
      },

      cancelSelectedSlot (slot) {
        this.controller.loading = true;

        const id = slot.id;

        this.$api.get('/driver/schedule/cancel', { params: { slot_id: id, issue: 1 } })
          .then(response => {
            console.log('cancelSelectedSlot => ',response);
            if(response.status==200){
              this.controller.selected = null;

              const step = this.setStepText();
              // propagate updated step to parent
              this.$nextTick(() => {
                this.$emit('update', step);
              });

              this.toggleToast(
                true,
                this.$t('signup.steps.SCH.canceled'),
                5000,
                false,
              );

              this.trackEvent('signup/'+this.stepName, 'cancel installation ok');
            }else{
              this.toggleToast(
                true,
                this.$t('signup.steps.SCH.errors.cancel'),
                5000,
                false,
              );
              this.trackEvent('signup/'+this.stepName, 'cancel installation failed');
            }
          })
          .catch(error => {
            this.handleError(error, this.$t('calendar.cancel_failed'), true);
          })
          .finally(() => {
            this.getCalendarSlots();
            this.controller.loading = false;
          });
      },

      getCurrentSchedule () {
        return this.$api.get('/driver/schedule/current')
          .then(response => {
            console.log('getCurrentSchedule => ', response.data);
            const slot = response.data;
            if (_.isNil(slot) || _.isEmpty(slot)) {
              return null;
            }
            return {
              id: slot.id,
              start: slot.start || slot.inicio,
              end: slot.end || slot.fim,
              type: slot.type,
            };
          })
          .catch(error => {
            this.handleError(error, false);
            return null;
          });
      },

      getCalendarSlots () {
        this.controller.loading = true;

        const type = 'INS';

        Promise.all([
          this.$api.get('/driver/schedule/slots/'+type+'/'),
          this.getCurrentSchedule(),
        ])
          .then(([response, current]) => {
            console.log('getCalendarSlots => ',response.data);
            const data = response.data;
            const rawSlots = _.isArray(data)
              ? data
              : (data?.slots || data?.eventosLivres || []);

            if(response.status==200){
              let slots = _.groupBy(_.map(rawSlots, e => {
                return {
                  id: e.id,
                  start: e.start || e.inicio,
                  end: e.end || e.fim,
                  type: e.type,
                }
              }), s => this.$moment(s.start).format('YYYY-MM-DD') );
              slots = _.mapValues(slots, s => {
                return _.keyBy(s, v => this.$moment(v.start).hour() );
              })
              console.log('slots', slots);

              this.controller.slots = slots;
              this.controller.selected = current;

              const step = this.setStepText();
              // propagate updated step to parent
              this.$nextTick(() => {
                this.$emit('update', step);
              });

              this.trackEvent('signup/'+this.stepName, 'get installation slots ok');
            }else{
              this.toggleToast(
                true,
                this.$t('signup.steps.SCH.errors.get'),
                5000,
                false,
              );
              this.trackEvent('signup/'+this.stepName, 'get installation slots failed');
            }
          })
          .catch(error => {
            this.handleError(error);
          })
          .finally(() => {
            this.controller.loading = false;
            if (this.refresh) this.$emit('onRefresh');
          });
      },

      setStepText (step=this.step) {
        if (!!this.controller.selected) {
          step.title = 'signup.steps.SCH.scheduled_title';
          step.subtitle = 'signup.steps.SCH.scheduled_subtitle';
        }else{
          step.title = 'signup.steps.SCH.title';
          step.subtitle = 'signup.steps.SCH.subtitle';
        }
        return step;
      }

    },

    created () {
    },

    mounted () {
      this.getCalendarSlots();
      this.setStepText();
    },

    directives: {
    },

  }
</script>
